/**
 * PerFteCard Component
 * Revenue per Employee and Gross Margin per Billable FTE
 */

import { CommentButton } from './CommentButton';
import { formatCurrency } from '@/utils/formatters';
import type { PerFteMetrics } from '@/types/scalingUp';

interface PerFteCardProps {
  data: PerFteMetrics | null;
  loading: boolean;
  onInsight?: () => void;
}

export function PerFteCard({ data, loading, onInsight }: PerFteCardProps) {
  if (loading && !data) {
    return (
      <div className="scaling-up__card">
        <h2 className="scaling-up__card-title">Per-FTE Metrics</h2>
        <div className="skeleton" style={{ height: '100px' }} />
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className="scaling-up__card">
      <div className="scaling-up__card-header">
        <h2 className="scaling-up__card-title">Per-FTE Metrics</h2>
        {onInsight && (
          <button
            className="trend-chart__ai-btn"
            onClick={onInsight}
            title="AI Insights — per-FTE analysis"
            aria-label="AI Insights for Per-FTE Metrics"
          >
            AI
          </button>
        )}
        <CommentButton targetType="metric" targetId="per-fte" />
      </div>
      <div className="per-fte">
        <div className="per-fte__metric">
          <span className="per-fte__value">
            {formatCurrency(data.revenuePerEmployee)}
          </span>
          <span className="per-fte__label">
            Revenue / Employee ({data.totalHeadcount} people)
          </span>
        </div>
        <div className="per-fte__metric">
          <span className="per-fte__value">
            {formatCurrency(data.grossMarginPerFte)}
          </span>
          <span className="per-fte__label">
            Gross Margin / Billable FTE ({data.billableFte} FTE)
          </span>
        </div>
      </div>
    </div>
  );
}
